import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
@Injectable()
export class RefreshPageService {
  //labels: any;
  constructor(private router: Router, private activeRouter: ActivatedRoute) {}

  valueSub = new Subscription();

  pageRefresh() {
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };
    this.valueSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.router.navigated = false;
      }
    });
  }
}
